module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-300italic.woff2?263658ab20600be255b10da96fe872b5";